import { getCurrentUser } from '@src/service/business/login/loginBusinessService';
import { INote } from '@src/model/user/Note';
export class UserNoteUtils {
  static isAuthorCurrentUser = (note: INote): boolean => {
    return note.createdBy.id === getCurrentUser().id;
  };
}
